import BaseSvg from './BaseSvg'

const Wand = ({ title = 'Magic Wand', ...rest }: { title: string }) => (
  <BaseSvg viewBox={'0 0 18 18'} title={title} {...rest}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M2.25 0l1.125 2.25L2.25 4.5 4.5 3.375 6.75 4.5 5.625 2.25 6.75 0 4.5 1.125zM13.5 0l1.125 2.25L13.5 4.5l2.25-1.125L18 4.5l-1.125-2.25L18 0l-2.25 1.125zM13.5 11.25l1.125 2.25-1.125 2.25 2.25-1.125L18 15.75l-1.125-2.25L18 11.25l-2.25 1.125zM7.078 8.534l2.978-2.978 2.386 2.387-2.977 2.977zM0 15.613L6.284 9.33l2.387 2.386L2.387 18z" />
    </g>
  </BaseSvg>
)

Wand.displayName = 'WandIcon'

export default Wand
